<section class="section-welcome container">
  <div class="left">
    <h1>Você pode solicitar a correção de
      seus dados pessoais que sejam
      tratados pela Serasa Experian e
      eventualmente estejam incompletos,
      inexatos ou desatualizados.
    </h1>
  </div>
  <div class="right hidden-xs">
    <img src="assets/illustration-pc.svg" alt="Ilustração - Direitos de correção">
  </div>
</section>
<div class="gray-area">
  <div class="container">
    <div class="card">
      <div id="card-menu-dir-correcao" class="nav flex-column nav-pills" id="v-pills" role="tablist"
        aria-orientation="vertical">

        <a id="itemDados-card-menu-dir-correcao" class="nav-link" [ngClass]="{'active': itemDados == true}"
          (click)="menuAtivo('dados')" [routerLink]="['./']" fragment="dados" data-toggle="tab"
          aria-controls="v-pills-dados">Revisão de Dados negativos</a>

        <a id="itemPositivos-card-menu-dir-correcao" class="nav-link" [ngClass]="{'active': itemPositivos == true}"
          (click)="menuAtivo('positivos')" [routerLink]="['./']" fragment="positivos" data-toggle="tab"
          aria-controls="v-pills-positivos" selected>Revisão de Informações do Cadastro Positivos</a>

        <a id="itemCadastrais-card-menu-dir-correcao" class="nav-link" [ngClass]="{'active': itemCadastrais == true}"
          (click)="menuAtivo('cadastrais')" [routerLink]="['./']" fragment="cadastrais" data-toggle="tab"
          aria-controls="v-pills-cadastrais">Informações Cadastrais</a>

      </div>
    </div>


    <div class="message-area">
      <h1 id="dados">Revisão de Dados Negativos<br></h1>

      <p>Em alguns momentos será necessário revisar um dado negativo para deixar suas informações atualizadas. <br><br>

        Por exemplo: se você quitou uma dívida, mas a informação continua na base da Serasa Experian,
        ou no caso de dívida indevida após roubo, fraude, clonagem ou perda de documentos,
        ou se precisar retificar ou atualizar dados de uma negativação ou, ainda,
        regularizar uma anotação de cheque sem fundos, siga o passo a passo abaixo.
      </p>
      <h2>Você já realizou o pagamento e a informação continua na base? <br>
      </h2>

      <p>Após o pagamento da dívida, a empresa ou banco credor deve excluir a dívida na base de
        dados da Serasa Experian. <br>

      </p>

      <p> Caso a informação não seja excluída em 5 dias úteis após o pagamento, entre em contato
        com a empresa ou banco credor para que realize a baixa. <br>
      </p>

      <p> Você também pode solicitar a atualização diretamente à Serasa. Envie requerimento detalhando
        a anotação, acompanhada dos documentos que comprovem o pagamento da dívida. <br>
      </p>

      <app-alert [id]="'pagamento-mensagem'" [tipo]="'info'">
        Importante: Antes da baixa,
        as solicitações serão encaminhadas para confirmação do credor. No caso de anotações no SPC, as solicitações
        serão
        encaminhadas para que este realize a atualização em sua base, sendo que as atualizações serão automaticamente
        refletidas nos extratos da Serasa.
      </app-alert>

      <h2>Você foi vítima de roubo, fraude, clonagem ou perda de documentos, e isso gerou uma dívida indevida em seu
        nome?
      </h2>

      <p>O primeiro passo é formalizar esse pedido de exclusão por meio do envio das seguintes informações para a
        Serasa:

        Descrição escrita de próprio punho, com seu nome, endereço, documento oficial com foto que possua o número do
        seu CPF e, se possuir, e-mail;

        O boletim de ocorrência assinado pela autoridade policial;

        Comprovante de sustação de cheque (se for o caso) com o BO.
      </p>
      <app-alert [id]="'vitima-mensagem'" [tipo]="'info'">
        Importante: Não se esqueça
        de especificar, na descrição escrita por você, qual é a anotação indevida, declarando, sob as penas da lei,
        que foi uma contratação fraudulenta realizada por um terceiro. Importante que você procure também o suposto
        credor para que o problema seja resolvido na sua origem.
      </app-alert>


      <h2>Deseja retificar ou atualizar os dados de uma negativação?</h2>

      <p>Entre em contato com a empresa ou banco credor para pedir que altere ou atualize a informação enviada à a
        Serasa.
        Se preferir solicitar a retificação diretamente à Serasa, envie requerimento detalhando a anotação que deseja
        retificar, acompanhada dos documentos que comprovem os dados atualizados e, se tiver, histórico dos contatos
        realizados anteriormente com o credor.
      </p>

      <app-alert [id]="'negativacao-mensagem'" [tipo]="'info'">
        Importante: Antes da alteração
        dos dados, as solicitações serão encaminhadas para confirmação do credor. No caso de anotações no SPC, as
        solicitações
        serão encaminhadas para que este realize a correção em sua base.
      </app-alert>

      <h2>Deseja regularizar uma anotação de cheque sem fundos?</h2>

      <p>Envie requerimento detalhado a anotação que deseja retificar, acompanhada dos documentos que comprovem os dados
        atualizados e,
        se tiver, histórico dos contatos realizados anteriormente com o credor. É importante que indique exatamente os
        dados que
        deseja retificar (número do banco, agência, número do cheque, data, valor, motivo da devolução, data da inclusão
        e quantidade de cheques). <br>
      </p>

      <p>Para regularizar suas anotações de cheques sem fundos diretamente na origem, seguir o passo a passo abaixo:
      </p>

      <p>1) Vá a qualquer agência do seu banco e peça os dados do cheque (número do banco, agência, número do cheque,
        data,
        valor, motivo da devolução, data da inclusão e quantidade de cheques) que foi incluído no CCF (Cadastro de
        Emitentes de Cheques sem Fundos);
      </p>

      <p>2) Com esses dados, descubra no canhoto do talão para quem você passou o cheque;</p>

      <p>3) Procure essa empresa ou pessoa e regularize o débito;</p>

      <p>4) Pegue o cheque de volta. <b>Atenção:</b> não jogue fora!</p>

      <p>5) Com o cheque em mãos, compareça à agência bancária que incluiu
        o seu cheque no CCF e siga as demais orientações do banco.
      </p>

      <p>6) A agência bancária deverá solicitar a baixa do cheque, e
        após essa solicitação, a base de dados da Serasa será atualizada. <br><br>
      </p>

      <p>Você também pode enviar um requerimento à Serasa Experian, veja quais são as opções:</p>

      <p>Correios<br>Endereço: Avenida Doutor Heitor José Reali, 360, Distrito Industrial Miguel Abdelnur São Carlos/SP
        - CEP 13571-385.</p>


      <app-alert [id]="'anotacao-mensagem'" [tipo]="'info'">
        Atenção: as cópias enviadas devem ser autenticadas e com firma reconhecida, ok?
      </app-alert>

      <h1 id="positivos">Revisão de Informações Positivas </h1>

      <p>Você pode consultar suas informações a qualquer momento, de forma gratuita. Caso encontre alguma
        informação divergente no seu relatório de Informações Positivas, nós podemos te apoiar na sua
        solicitação de revisão.
      </p>

      <h2>O que é o processo de revisão de dados do Cadastro Positivo?</h2>

      <p>O consumidor que autoriza a abertura do seu Cadastro Positivo ao mercado passa a ter suas
        informações incluídas nos Gestores de Bancos de Dados, como a Serasa Experian, que participam
        deste processo. Ele pode consultar suas informações a qualquer momento, de forma gratuita e ilimitada.
        Vale ressaltar que as informações são disponibilizadas para consulta em até 7 (sete) dias a partir
        da abertura do Cadastro Positivo e atualizadas semanalmente.  Se for identificada alguma divergência
        ou se o consumidor não reconhecer alguma informação, ele tem o direito de solicitar a correção ao
        Gestor de Banco de Dados por meio da abertura de uma contestação.  O Gestor de Banco de Dados verificará
        a solicitação de contestação do consumidor e repassará à empresa credora (instituição financeira,
        empresa varejista, concessionária de serviço público, consórcio, ou prestador de serviços com pagamento
        continuado) que originou as informações para avaliação e correção. Em caso de haver procedência, a
        informação será corrigida pela empresa credora e disponibilizada pelo Gestor de Banco de Dados.
        O consumidor poderá ainda solicitar a revisão de seus dados diretamente à empresa credora desde que
        seja cliente da mesma e as informações se refiram àquela instituição.
      </p>

      <h2>Eu paguei uma parcela ou fatura em dia, porém, no relatório do Cadastro Positivo aparece que não
        foi paga ou paga em data posterior ao vencimento. Por quê?
      </h2>

      <p>Verifique se o vencimento da sua fatura foi sábado, domingo ou feriado. Por conta do expediente bancário,
        quando um vencimento ocorre no final de semana ou feriado, o pagamento pode levar até 10 dias para ser
        atualizada devido a data de apuração do pagamento de cada instituição financeira e o tempo de
        processamento da informação.
      </p>

      <h2>Qual o prazo para que as informações sejam corrigidas?</h2>

      <p>O prazo para a correção e divulgação das informações é de até 10 (dez) dias corridos.</p>

      <h2>Caso a empresa credora não se manifeste no período de 10 (dez) dias, o que acontecerá?</h2>

      <p>Neste caso, a Serasa Experian não disponibilizará a informação contestada ao mercado até que
        a empresa credora se manifeste.
      </p>

      <h2>Qual o período das informações disponibilizadas pelos Bancos de Dados ao mercado?</h2>

      <p>Os Gestores de Bancos de Dados disponibilizam ao mercado as informações enviadas pelas
        empresas credoras nos últimos 12 (doze) meses mais o mês atual.
      </p>

      <h2>Por que as informações de pagamento do meu credito consignado em folha de pagamento
        estão desatualizadas no meu cadastro?
      </h2>

      <p>Devido às características da operação, o repasse dos valores retidos pela empresa leva
        um tempo maior para ser enviado para a instituição credora, somente quando o repasse é
        concretizado que a instituição pode reconhecer o pagamento. Caso haja dúvidas sobre este
        processo, você pode entrar em contato com a instituição credora responsável e verificar a
        divergência de informações.
      </p>

      <h2>Por que o Gestor de Banco de Dados está divulgando informações referentes a um cartão
        de crédito que já foi cancelado nos últimos 12 meses?
      </h2>

      <p>Os Bancos de Dados disponibilizam ao mercado as informações enviadas pelas empresas
        credoras nos últimos 12 (doze) meses mais o mês atual, mesmo que as dívidas já estejam
        quitadas ou canceladas.
      </p>

      <h2>O Gestor de Banco de Dados está mostrando pagamento de cartão de crédito em atraso
        sendo que realizei diversos pagamentos avulsos durante o mês. Por quê?
      </h2>

      <p>Porque atualmente as instituições credoras enviam aos Bancos de Dados o valor total dos
        pagamentos realizados e considera somente a última data de pagamento.
      </p>

      <h2>O Gestor de Banco de Dados está divulgando uma operação de um cartão de crédito que
        desconheço. Por quê?
      </h2>

      <p>Você deve verificar com a Instituição Credora se foi gerado um cartão de crédito e se
        este não foi desbloqueado e ativado até o momento.
      </p>

      <h1 id="cadastrais">Informações Cadastrais</h1>

      <p>Você pode solicitar a alteração de suas informações cadastrais na Serasa de forma gratuita.
        Isso pode te ajudar a facilitar a concessão de crédito em bancos, financeiras, seguradoras e
        administradoras de cartão. Através do nosso site é possível atualizar suas informações cadastrais,
        basta escolher a opção “Outras soluções” no Menu principal e "Formulário de atualização cadastral" em seguida.
      </p>

      <h2>Atualização Cadastral Online</h2>

      <ol>
        <li>
          <p> Acesse este link: <a href="https://www.serasa.com.br/area-cliente/solucoes"
              target="_blank"><u>https://www.serasa.com.br/area-cliente/solucoes</u></a></p>
        </li>
        <li>
          <p> Faça o login de autenticação e escolha a opção "Formulário de Atualização Cadastral", que está no menu de
            "Soluções";</p>
        </li>
        <li>
          <p> Escolha as informações que você quer atualizar, entre dados pessoais, de endereço, de renda ou bancários;
          </p>
        </li>
        <li>
          <p> Anexe os documentos indicados no final deste artigo, de acordo com cada solicitação;</p>
        </li>
        <li>
          <p> Prontinho! Agora nosso time de especialistas vai analisar a documentação e, se estiver tudo correto, fazer
            a
            atualização. O prazo para atualização é de cinco dias úteis.</p>
        </li>

      </ol>


      <h2>Atualização Cadastral via Correios</h2>

      <ol>
        <li>
          <p> Baixe e imprima o Formulário de Atualização Cadastral disponível <a
              href="https://ajuda.serasa.com.br/hc/pt-br/article_attachments/4416711228941/Form._Atualiza__o_Cadastral.pdf"
              target="_blank"><u>aqui</u></a></p>
        </li>
        <li>
          <p> Leia o termo de responsabilidade que se encontra abaixo dos campos de preenchimento do formulário;</p>
        </li>
        <li>
          <p> Preencha os campos dos dados que você deseja atualizar. Lembre-se de assinar e reconhecer firma ao final
            do
            documento;</p>
        </li>
        <li>
          <p> Envie o termo preenchido junto com a documentação comprobatória por correio para a Serasa, no endereço
            abaixo:
          </p>
        </li>
      </ol>

      <p>Avenida Doutor Heitor José Reali, 360 <br />
        Distrito Industrial Miguel Abdelnur <br />
        CEP 13571-385 - São Carlos-SP</p>

      <h2>IMPORTANTE</h2>
      <p>Os dados cadastrais somente serão atualizados após a análise de todos os documentos enviados. Caso sejam
        identificadas inconsistências,
        será necessário enviar um novo formulário contendo a documentação comprobatória anexa para nova análise.</p>

      <h2>Documentação necessária:</h2>

      <p><b>1) Comprovante de identificação:</b> cópias do CPF e do documento de identificação legível e com foto (RG,
        CNH,
        carteira de trabalho, carteira de identidade profissional, passaporte brasileiro, carteira de identificação
        funcional,
        documentos de identificação militares, RNE, CIE, passaporte estrangeiro com tradução juramentada realizada no
        Brasil);
      </p>
      <p>Atenção</p>

      <ul>
        <li>
          <p>Os documentos de identificação devem estar dentro do prazo de validade;</p>
        </li>
        <li>
          <p>Os documentos de identificação que não têm prazo de validade devem ter sido emitidos há no máximo 20 anos;
          </p>
        </li>
        <li>
          <p>Não serão aceitos quaisquer documentos diferentes dos listados acima. Caso você possua dois documentos do
            mesmo
            órgão emissor, anexe o documento com data mais recente.</p>
        </li>
      </ul>

      <p><b>2) Comprovante de residência:</b> contas de consumo frente e verso, emitido há no máximo 3 meses.
        São válidos os seguintes documentos (documentos aceitos em seu nome):</p>
      <ul>
        <li>
          <p>Conta de telefone fixo ou móvel;</p>
        </li>
        <li>
          <p>TV por assinatura;</p>
        </li>
        <li>
          <p>Internet fixa;</p>
        </li>
        <li>
          <p>Água, luz, gás;</p>
        </li>
        <li>
          <p>Fatura de cartão de crédito (exceto cartões exclusivos de loja e sem bandeira);</p>
        </li>
        <li>
          <p>Boleto de aluguel;</p>
        </li>
        <li>
          <p>Boleto de condomínio.</p>
        </li>
      </ul>
      <p>Atenção</p>

      <ul>
        <li>
          <p>Serão aceitos comprovantes de residência em nome dos pais, desde que estes constem no seu documento de
            identificação, e do cônjuge com a apresentação da certidão de casamento;</p>
        </li>
        <li>
          <p>Caso não tenha nenhum comprovante de residência em seu nome, você deverá apresentar uma declaração
            comprovando o
            local de residência, com firma reconhecida da assinatura do terceiro juntamente com uma cópia do comprovante
            de
            residência em nome do terceiro;</p>
        </li>
        <li>
          <p>Não serão aceitas cartas de boas-vindas, habilitação de serviço, conta de telefone ou internet móvel,
            boletos
            (convênio médico, condomínio, cursos, IPTU, IPVA) ou quaisquer documentos diferentes dos documentos listados
            acima;</p>
        </li>
        <li>
          <p>A cópia do comprovante de endereço deve ser completa e com o código de barras. Só não há necessidade de ter
            código de barras quando é débito automático (obrigatoriamente descrito na fatura) ou quando consta o
            comprovante
            de pagamento anexo, sendo possível realizar a validação.</p>
        </li>
      </ul>

      <p><b>3) Comprovante de renda:</b> emitido há no máximo 3 meses.</p>
      <p>São válidos os seguintes documentos:</p>

      <ul>
        <li>
          <p>Holerite, exceto referente ao período de férias e adiantamento (deve conter o nome da empresa, período
            equivalente e valores);</p>
        </li>
        <li>
          <p>Declaração de imposto de renda recente (último) completo e com a identificação da fonte pagadora;</p>
        </li>
        <li>
          <p>Declaração comprobatória de percepção de rendimentos – Decore (é necessário ter a assinatura e os dados do
            contador);</p>
        </li>
        <li>
          <p>Extrato do INSS (com o número do benefício);</p>
        </li>
        <li>
          <p>Retirada de rendimentos pelos sócios (Pró- Labore).</p>
        </li>
      </ul>
      <p>Atenção</p>
      <ul>
        <li>
          <p>Caso a renda contenha variável ou comissionamento é necessário apresentar os três últimos comprovantes. Não
            serão
            aceitas declarações de rendimentos/faturamento, extrato bancário ou quaisquer documentos diferentes dos
            documentos
            listados acima.</p>
        </li>
      </ul>

      <p><b>4) Casos especiais:</b></p>
      <p>a) Portador de necessidades especiais (Decisão Apoiada);</p>
      <ul>
        <li>
          <p>No formulário deverão constar os dados do interessado e a assinatura deverá ser do interessado e dos
            apoiadores.
            As assinaturas devem conter firma reconhecida em cartório. É preciso incluir cópia do Termo de Decisão
            Apoiada
            homologado pelo juiz, contendo os limites do apoio e o prazo de vigência, bem como a indicação das pessoas
            que
            prestarão o apoio. Anexar a cópia dos documentos de identificação dos apoiadores e do interessado (apoiado),
            além
            da cópia dos documentos do interessado, conforme itens 2 e 3.</p>
        </li>
      </ul>
      <p>b) Atualização por terceiro (procurador);</p>
      <ul>
        <li>
          <p>No formulário deverão constar os dados do interessado e a assinatura deverá ser do Procurador com firma
            reconhecida em cartório.</p>
        </li>
        <li>
          <p>Anexar a procuração/autorização (original ou cópia), com firma reconhecida em cartório e poderes
            específicos para
            atualizar dados cadastrais na base de dados da Serasa Experian. Anexe a cópia dos documentos de
            identificação do
            procurador e do interessado, além da cópia dos documentos do interessado, conforme itens 2 e 3.</p>
        </li>
      </ul>
      <p>c) Não alfabetizados;</p>
      <ul>
        <li>
          <p>O interessado deverá ir ao Tabelião de Notas com o Formulário de Atualização Cadastral em mãos para lavrar
            uma
            declaração pública com todas as informações que deseja atualizar.</p>
        </li>
        <li>
          <p>A declaração pública deverá ser assinada por outra pessoa a seu pedido, na presença do agente delegado do
            Poder
            Público.</p>
        </li>
        <li>
          <p>O Tabelião de Notas é responsável por cumprir todas as exigências da lei.</p>
        </li>
        <li>
          <p>Deve constar na Declaração Pública: a assinatura das partes, do escrevente e do Tabelião ou de seu
            substituto. Se
            não puder ou não souber assinar, um terceiro pode assinar pelo interessado, neste caso, é necessário colher
            impressão digital, exclusivamente com a utilização de coletores de impressões digitais, não é permitido o
            uso de
            tinta para carimbo. Anexar a cópia dos documentos de identificação do interessado, além da cópia dos
            documentos
            comprobatórios, conforme itens 2 e 3.</p>
        </li>
      </ul>
      <p>d) Idoso e Portador de Necessidades Especiais (Curador)</p>

      <ul>
        <li>
          <p>No formulário deverão constar os dados do interessado e a assinatura deverá ser do curador com firma
            reconhecida
            em cartório.</p>
        </li>
        <li>
          <p>No formulário deverá constar a observação que foi assinada pelo Curador e informar que o interessado é
            incapaz de
            assinar.</p>
        </li>
        <li>
          <p>É preciso incluir uma cópia do Termo de Curatela, observados os limites do documento. Anexe a cópia dos
            documentos de identificação do curador e do interessado (curatelado), além da cópia dos documentos do
            interessado,
            conforme itens 2 e 3.</p>
        </li>
      </ul>
      <p>Não encontrou o que procurava?</p>
      <button id="id-button-central-ajuda-ticket" (click)="redirectCentralAjudaTicket()">Envie uma
        solicitação</button><br><br>
    </div>
  </div>
</div>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>
